import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTheme, withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getLightBorder } from 'Components/utils';
import { localStorageMap } from 'Consts/localStorage';
import ResizableBox from 'Components/ComponentLibrary/Atoms/ResizableBox';
import fr from 'facet-rest';
import { ProposalScenarioPXForms } from 'Components/ComponentLibrary/Organisms/ProposalScenarioPXForms';
import Header from './Header';
import TabsPicker from './TabsPicker';

const styles = (theme) => ({
  root: {
    ...getLightBorder(theme, { right: true }),
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {},
  tabs: {},
});

const LeftSide = ({
  className,
  classes,
  resource,
}) => {
  const theme = useTheme();

  return (
    <ResizableBox
      className={classNames(classes.root, className)}
      side={'right'}
      localStorageName={localStorageMap.scenarioLeftSideWidth}
      minSize={theme.dimensions.md}
    >
      <Header className={classes.header} />
      {resource.withRelationship(fr.relationships.proposalScenarioPX.name, (rel) => {
        return (
          <ProposalScenarioPXForms relationshipLink={rel.link('related')} />
        );
      }, () => {
        return (<TabsPicker className={classes.tabs} />);
      })}
    </ResizableBox>
  );
};

LeftSide.defaultProps = {
  className: '',
};

LeftSide.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(LeftSide);
